/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'plugin.tooltip',
    'pip-events',
    'pip-model',
    'window',
],
    function (
        $,
        tooltip,
        pipEvents,
        pip,
        window
    ) {
        var view = {
            selectors: {
                tooltip: ''
            },
            templates: {
                tooltip: 'We\'ve set this item\'s price lower than the manufacturer will let us advertise,  \
                          so you\'ll have to add it to your cart to see our price. If you decide you don\'t \
                          want to purchase the item, you can remove it from your cart.'
            },
            attachTooltips: function () {
                $(view.selectors.tooltip).tooltip({
                    type: 'click',
                    content: function () {
                        return view.templates.tooltip;
                    },
                    onOpen: function googleAnalytics(content, open) {
                        triggerAnalytics();
                        open();
                    },
                    closeButton: true,
                    closeOnClick: true
                }); 
            }
        };

        function triggerAnalytics () {
            pipEvents.priceDetails.priceDetailsLinkClicked.trigger({
                eventName: 'map disclosure'
            });
        }

        return {
            init: function init(tooltipSelector) {
                view.selectors.tooltip = tooltipSelector;
                view.attachTooltips();
            }
        }
    }
);

}.call(window));